module.exports = __webpack_public_path__ + "static/what-leaders-really-do-d35ddbf1afc0662f810362a7ba6dd64a.jpg";